import { render, staticRenderFns } from "./three-column-layout.vue?vue&type=template&id=22092753&scoped=true"
import script from "./three-column-layout.vue?vue&type=script&lang=js"
export * from "./three-column-layout.vue?vue&type=script&lang=js"
import style0 from "./three-column-layout.vue?vue&type=style&index=0&id=22092753&prod&scoped=true&lang=css"
import style1 from "./three-column-layout.vue?vue&type=style&index=1&id=22092753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22092753",
  null
  
)

export default component.exports